module.exports = __webpack_public_path__ + "media/images/home/home-footer-e8ca7d37236faea4e4d9e3e71c0f0a8d.png";